import { render, staticRenderFns } from "./yingsi.vue?vue&type=template&id=49dd42dd&scoped=true&"
import script from "./yingsi.vue?vue&type=script&lang=js&"
export * from "./yingsi.vue?vue&type=script&lang=js&"
import style0 from "./yingsi.vue?vue&type=style&index=0&id=49dd42dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dd42dd",
  null
  
)

export default component.exports